// Using document ready instead of on turbo load since this contains ONLY document bound functions
$(document).ready(function() {

  // ONLY SUPPORTS DOCUMENT BOUND FUNCTIONS IN $(document).ready(...) DUE TO TURBO

  $(document).on('click', '.brands-ranker-component .brand-units-sort', function() {
    const component = $(this).closest('.brands-ranker-component');
    const timeline = component.closest('.card').find('.brand-ranker-select').val();
    const sort = $(this).attr('sort_by');
    const sort_dir = $(this).attr('sort_dir');
    component.find('.highlight-selected-sort .fa').remove();
    component.find('.brand-units-sort').removeClass('highlight-selected-sort');
    $(this).addClass('highlight-selected-sort');

    reloadBrandRanker(component, timeline, sort, sort_dir);
  });

  $(document).on('change', '.card .brand-ranker-select', function() {
    const component = $(this).closest('.card').find('.brands-ranker-component');
    const timeline = $(this).val();
    const sort = 'units';
    reloadBrandRanker(component, timeline, sort);
  });

  $(document).on('click', '.brand-ranker-custom-date-fields .brand-ranker-custom-submit-btn', function() {
    const component = $(this).closest('.card').find('.brands-ranker-component');
    const timeline = 'Custom';
    const sort = 'units';
    reloadBrandRanker(component, timeline, sort);
  });

  $(document).on('click', '.brands-ranker-component .see-more-brands', function() {
    const brandRows = $('.brands-ranker-component tr')
    brandRows.each(index => {
      const row = brandRows[index];
      row.classList.remove('d-none');
    })
    $(this).addClass('d-none');
  });

  function reloadBrandRanker(component, timeline, sort, sort_dir = 'desc') {
    let customStart = null;
    let customEnd = null;

    if (timeline === 'Custom') {
      // If user selects custom, show the custom date fields.
      component.closest('.card').find('.brand-ranker-custom-date-fields').removeClass('d-none');
      const parent = component.closest('.card').find('.brand-ranker-custom-date-fields');
      customStart = parent.find('input[name=start_date]').val();
      customEnd = parent.find('input[name=end_date]').val();
      if (customStart === '' || customEnd === '') return; // Return so we don't reload the ranker.
    } else if (timeline !== 'Custom') {
      // Hide custom date fields if applicable.
      component.closest('.card').find('.brand-ranker-custom-date-fields').addClass('d-none');
    }

    const hidden = component.attr('hide_zero_units');
    const anonymous = component.attr('anonymous');
    const currBrandId = component.attr('current_brand_id');
    const currBrandGroupId = component.attr('current_brand_group_id');
    const rankGroups = component.attr('rank_groups');
    const userIds = component.attr('user_ids');
    const acceptBrandIds = component.attr('acceptable_brand_ids')
    const categoryEl = $('select[name="business_category"]');
    const businessCategory =
        categoryEl.val() || component.attr('business_category') || '';
    const momentumEl = $('select[name="momentum_membership"]');
    const momentumMembership =
        momentumEl.val() || component.attr('momentum_membership') || '';
    component.find('tr:not(:first-child)').remove();
    component.find('.see-more-brands').remove();
    const loadingDots = component.closest('.card').find('#brand-ranker-loading');
    loadingDots.removeClass('d-none');
    // Pre-made params for the URL, do not need to be prefixed and can be listed back to back
    const customTimelineParams = customStart !== null && customEnd !== null ? `&timeline_custom_start=${customStart}&timeline_custom_end=${customEnd}` : ''
    const brandIdParam = currBrandId ? `&current_brand_id=${currBrandId}` : ''
    const brandGroupIdParam = currBrandGroupId ? `&current_brand_group_id=${currBrandGroupId}` : ''
    const rankGroupsParam = rankGroups ? `&rank_groups=${rankGroups}` : ''
    const userIdsParam = userIds ? `&user_ids_string=${userIds}` : ''
    const acceptBrandIdsParam = acceptBrandIds ? `&acceptable_brand_ids_string=${acceptBrandIds}` : ''
    const categoryParam     = businessCategory  ? `&business_category=${encodeURIComponent(businessCategory)}` : '';
    const momentumParam     = momentumMembership ? `&momentum_membership=${encodeURIComponent(momentumMembership)}` : '';
    $.get(`/components/brands/ranker?timeline=${timeline}&hide_zero_units=${hidden}&anonymous=${anonymous}&sort=${sort}&sort_dir=${sort_dir}${customTimelineParams}${brandIdParam}${brandGroupIdParam}${rankGroupsParam}${userIdsParam}${acceptBrandIdsParam}${categoryParam}${momentumParam}`).done(function(html) {
      component.replaceWith(html);
      $('[data-bs-toggle="tooltip"]').tooltip();
    });
  }
});
